<!-- src/views/ServicesView.html -->
<div class="view-container">
  <div class="header-section">
    <div>
      <h1 class="view-title">Gestione Servizi</h1>
      <p class="view-desc">Configura il tuo listino prezzi, le durate, e i requisiti di sala e personale.</p>
    </div>
    <div>
      <button class="btn-primary rounded-soft" @click="openCreate">
        <Plus :size="18" /> Nuovo Servizio
      </button>
    </div>
  </div>

  <!-- Master Actions -->
  <div class="toolbar border-bottom pb-4">
    <div class="search-wrap">
      <Search :size="18" class="text-muted" />
      <input type="text" v-model="searchQuery" placeholder="Cerca servizio per nome..." class="search-input" />
    </div>
  </div>

  <!-- Master View (Grid of Dense Cards) -->
  <div class="services-list mt-2">
    <div v-if="filteredServices.length === 0" class="empty-state">
      <!--Nessun servizio corrisponde alla ricerca.-->
      <table class="data-table">
        <thead>
          <tr>
            <th style="width: 35%">Servizio Offerto</th>
            <th style="width: 15%">Prezzo</th>
            <th style="width: 15%">Durata</th>
            <th style="width: 25%">Competenze Richieste</th>
            <th style="width: 10%; text-align: right;">Azioni</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="filteredServices.length === 0">
            <td colspan="5" class="empty-state">Nessun servizio configurato</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="service-table-wrapper rounded-soft shadow-soft">
      <table class="data-table" v-if="filteredServices.length > 0">
        <thead>
          <tr>
            <th style="width: 35%">Servizio Offerto</th>
            <th style="width: 15%">Prezzo</th>
            <th style="width: 15%">Durata</th>
            <th style="width: 25%">Competenze Richieste</th>
            <th style="width: 10%; text-align: right;">Azioni</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="filteredServices.length === 0">
            <td colspan="5" class="empty-state">Nessun servizio configurato</td>
          </tr>
          <tr v-for="srv in filteredServices" :key="srv.id" class="service-row">
            <td class="font-medium text-light">
              <div class="srv-name">{{ srv.name }}</div>
              <div class="srv-desc line-clamp-1 text-muted">{{ srv.description || 'Nessuna descrizione.' }}</div>
            </td>
            <td>
              <div class="srv-price">
                <Euro :size="14" /> {{ Number(srv.price).toFixed(2) }}
              </div>
            </td>
            <td>
              <div class="srv-duration">
                <Clock :size="14" /> {{ srv.duration }} min
              </div>
            </td>
            <td>
              <span class="skill-summary" :title="getSkillNames(srv.requiredSkills)">
                {{ getSkillNames(srv.requiredSkills) }}
              </span>
            </td>
            <td class="actions-cell">
              <button class="btn-icon rounded-soft btn-edit" @click="openEdit(srv)" title="Modifica">
                <Edit :size="16" />
              </button>
              <button class="btn-icon rounded-soft btn-delete" @click="deleteService(srv.id)" title="Elimina">
                <Trash2 :size="16" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- OVERLAYS E DRAWERS -->
  <div class="drawer-overlay" :class="{ 'is-visible': isDrawerOpen }" @click="closeDrawer"></div>
  <div class="drawer drawer-dark" :class="{ 'is-open': isDrawerOpen }">
    <div class="drawer-header border-bottom">
      <h2>{{ serviceForm.id === 0 ? 'Nuovo Servizio' : 'Modifica Servizio' }}</h2>
      <button class="btn-close" @click="closeDrawer">
        <X :size="20" />
      </button>
    </div>

    <div class="drawer-body">
      <form @submit.prevent="saveService" id="srv-form">

        <!-- SECTION: Info Base -->
        <div class="form-section">
          <h3 class="section-title">Informazioni Base</h3>
          <div class="form-group">
            <label for="srvName">Nome Servizio *</label>
            <input type="text" id="srvName" v-model="serviceForm.name" required />
          </div>

          <div class="form-group">
            <label for="srvDesc">Descrizione</label>
            <textarea id="srvDesc" v-model="serviceForm.description" rows="2"
              placeholder="Es. Trattamento intensivo anticaduta..."></textarea>
          </div>

          <div class="form-row">
            <div class="form-group half-width">
              <label for="srvPrice">Prezzo (€) *</label>
              <div class="input-with-prefix">
                <span class="prefix">
                  <Euro :size="16" />
                </span>
                <input type="number" id="srvPrice" v-model.number="serviceForm.price" min="0" step="0.5" required />
              </div>
            </div>
            <div class="form-group half-width">
              <label for="srvDuration">Durata (min) *</label>
              <div class="input-with-prefix">
                <span class="prefix">
                  <Clock :size="16" />
                </span>
                <input type="number" id="srvDuration" v-model.number="serviceForm.duration" min="5" step="5" required />
              </div>
            </div>
          </div>
        </div>

        <!-- SECTION: Logica Prenotazione -->
        <div class="form-section mt-4">
          <h3 class="section-title">Logica di Assegnazione</h3>

          <div class="form-group">
            <label>Modalità selezione operatore</label>
            <div class="segmented-control">
              <label class="segment" :class="{'active': serviceForm.operatorMode === 'any'}">
                <input type="radio" v-model="serviceForm.operatorMode" value="any" />
                Qualsiasi (Random)
              </label>
              <label class="segment" :class="{'active': serviceForm.operatorMode === 'optimized'}">
                <input type="radio" v-model="serviceForm.operatorMode" value="optimized" />
                Ottimizzato dal Sistema
              </label>
              <label class="segment" :class="{'active': serviceForm.operatorMode === 'client'}">
                <input type="radio" v-model="serviceForm.operatorMode" value="client" />
                Scelta dell'utente
              </label>
            </div>
          </div>

          <div class="form-group toggle-group mt-3">
            <label class="toggle-label text-light">Gestione Consumo Magazzino / Prodotti</label>
            <label class="switch">
              <input type="checkbox" v-model="serviceForm.checkInventory">
              <span class="slider round"></span>
            </label>
          </div>
          <p class="helper-text ml-1 mt-1">Se abilitato, assocerai in cassa i prodotti consumati durante l'esecuzione
            del servizio.</p>
        </div>

        <!-- SECTION: Requisiti -->
        <div class="form-section mt-4">
          <h3 class="section-title">Competenze & Risorse Richieste</h3>

          <div class="form-group mb-4">
            <label>Competenze Staff Necessarie</label>
            <div class="multi-select-wrap">
              <button type="button" class="select-chip" v-for="skill in availableSkills" :key="'sk'+skill.id"
                :class="{'selected': serviceForm.requiredSkills.includes(skill.id)}"
                @click="toggleArraySelection(serviceForm.requiredSkills, skill.id)">
                <Check v-if="serviceForm.requiredSkills.includes(skill.id)" :size="14" class="chip-icon" />
                {{ skill.name }}
              </button>
            </div>
            <p class="helper-text mt-1">L'operatore scelto dovrà disporre di tutte le competenze qui marcate.</p>
          </div>

          <div class="form-group">
            <label>Risorse/Sale Limtanti (Opzionale)</label>
            <div class="multi-select-wrap">
              <button type="button" class="select-chip alt-chip" v-for="cat in availableResourceCategories"
                :key="'rc'+cat.id" :class="{'selected': serviceForm.requiredResourceCats.includes(cat.id)}"
                @click="toggleArraySelection(serviceForm.requiredResourceCats, cat.id)">
                <Layers v-if="serviceForm.requiredResourceCats.includes(cat.id)" :size="14" class="chip-icon" />
                {{ cat.name }}
              </button>
            </div>
            <p class="helper-text mt-1">Il sistema vieterà prenotazioni doppie che necessitino la stessa risorsa in
              esclusiva.</p>
          </div>
        </div>

        <div v-if="validationError" class="alert-error mt-4">
          <AlertCircle :size="16" />
          <span>{{ validationError }}</span>
        </div>

        <div class="form-section mt-4 border-top pt-4">
          <div class="flex-between">
            <h3 class="section-title">Regole Pagamento Speciali</h3>
            <label class="switch">
              <input type="checkbox" v-model="serviceForm.usePaymentOverride">
              <span class="slider round"></span>
            </label>
          </div>
          <p class="helper-text">Abilita per impostare una regola di pagamento specifica per questo servizio.</p>

          <div v-if="serviceForm.usePaymentOverride" class="payment-builder mt-3 p-3 bg-dark-soft rounded-soft">
            <div class="form-row">
              <div class="form-group half-width">
                <label>Tipo Regola</label>
                <select v-model="serviceForm.paymentRule.type">
                  <option value="free">Prenotazione Gratuita</option>
                  <option value="deposit">Richiedi Acconto</option>
                  <option value="full">Saldo / Totale</option>
                </select>
              </div>

              <div v-if="serviceForm.paymentRule.type === 'deposit'" class="form-group half-width">
                <label>Valore Acconto</label>
                <div class="input-group">
                  <input type="number" v-model.number="serviceForm.paymentRule.value" placeholder="10" />
                  <div class="input-group-append">
                     <select v-model="serviceForm.paymentRule.unit" class="unit-select">
                       <option value="%">%</option>
                       <option value="€">€</option>
                     </select>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="form-section mt-4 border-top pt-4">
          <div class="flex-between">
              <h3 class="section-title">Domande Pre-Prenotazione</h3>
              <label class="switch">
                  <input type="checkbox" v-model="serviceForm.hasQuestions">
                  <span class="slider round"></span>
              </label>
          </div>
          <p class="helper-text">Abilita domande specifiche che il cliente dovrà compilare.</p>

          <div v-if="serviceForm.hasQuestions" class="questions-builder mt-3">
            <div v-for="(q, index) in serviceForm.questions" :key="'q-' + index" class="question-card mb-3">
              <div class="form-row">
                <div class="form-group flex-grow">
                  <label>Testo della Domanda</label>
                  <input type="text" v-model="q.label" placeholder="Es. Hai allergie a particolari tinture?" />
                </div>
                <button type="button" class="btn-icon text-danger mt-4" @click="removeQuestion(index)">
                  <Trash2 :size="18" />
                </button>
              </div>

              <div class="form-row mt-2">
                <div class="form-group half-width">
                  <label>Tipo di Risposta</label>
                  <select v-model="q.type">
                    <option value="text">Testo Libero</option>
                    <option value="select">Scelta Multipla (Dropdown)</option>
                  </select>
                </div>
                <div class="form-group half-width" v-if="q.type === 'select'">
                  <label>Opzioni (separate da virgola)</label>
                  <input type="text" v-model="q.options" placeholder="Sì, No, Forse" />
                </div>
              </div>
            </div>

            <div class="mt-4 pt-2 border-top-dashed">
              <button type="button" class="btn-add-action" @click="addQuestion">
                <PlusCircle :size="18" />
                <span>Aggiungi una domanda</span>
              </button>
            </div>
          </div>
        </div>

      </form>
    </div>

    <!-- FOOTER: Sticky Bottom Buttons -->
    <div class="drawer-footer border-top drawer-sticky-footer">
      <button type="button" class="btn-secondary rounded-soft" @click="closeDrawer">Annulla</button>
      <button type="submit" form="srv-form" class="btn-primary rounded-soft">Salva Servizio</button>
    </div>
  </div>
</div>